import $ from 'jquery';

window.jQuery=window.$ = $;

const quc = $.getScript(`//s.ssl.qhimg.com/quc/quc7.js?_=${Date.now()}`);

export default quc;
